<template>
<div class="datepicker-input-container">
 <label :for="inputId" class="form-label"
          >{{ labelText }}
        </label>
<datepicker 
v-model="inputField"
:model-type="modelType"
:format="'dd/MM/yyyy'"
:enableTimePicker="false"
:inputClassName="inputClassName"
:locale= "it-IT"
:placeholder="''"
@update:modelValue="handleDate"
@open="onOpen"
@closed="onClose"
:autoApply="true"></datepicker>
<!-- <stdInputErrorMessage ref="stdErrorMessage"
  :errorMessageId="'datepicker-error-'+inputId"
  :okMessageId="'datepicker-ok-'+inputId"
  :errorText="this.intl[$store.state.lang]['date-error']"
  :okText="this.intl[$store.state.lang]['date-ok']"
></stdInputErrorMessage> -->
</div>
</template>

<script>
import intl from "./intl/intl";
//import StdInputErrorMessage from '../stdInputErrorMessage/StdInputErrorMessage.vue'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: "datePickerInput",
  components: {
   "datepicker": Datepicker,
  // "stdInputErrorMessage": StdInputErrorMessage
   
  },

  props: {
      
      inputId: {
        type: String,
        default: null
      },
      
      labelKey: {
        type: String,
        default: "base_label"
      },
      required: {
        type: Boolean,
        default: false
      },
      modelType: {
        type: String,
        default: "yyyy-MM-dd"
      }
      
     
        
  },
  mounted() {
   
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
      inputField: null,
      checkMessageOnChangeDate: false,
      inputClassName: "datepicker-base"
    };
  },
  methods: {
    handleDate(modelData){
    
      if(this.checkMessageOnChangeDate){
        this.checkMessage()
      }
    },
    onOpen(){
    if(this.inputClassName === "datepicker-base"){
        this.inputClassName = "datepicker-opened"
      }
    },
    onClose(){
      if(this.inputClassName === "datepicker-opened"){
        this.inputClassName = "datepicker-base"
      }
    },
     checkMessage(){
       if(this.required && this.inputField === null){
          //this.$refs["stdErrorMessage"].showErrorMessage()
          this.inputClassName = "datepicker-error"
       }else{
          //this.$refs["stdErrorMessage"].showOkMessage()
          this.inputClassName = "datepicker-ok"
       }
        this.checkMessageOnChangeDate=true
     },
  
    requiredInputIsOk(){
       if(this.required && this.inputField !== null){
         return true
       }else{
          return false
       }
       
    },
    
               
    
  
    
  },
  watch: {
   

  },
  computed: {
        labelText: function () {
      if(this.required){
        return this.intl[this.$store.state.lang][this.labelKey] + '*:'
      }else{
        return this.intl[this.$store.state.lang][this.labelKey] + ':'
      }
       
    },
    
    
    
    },
  
};
</script>
